import React from 'react';

export const ButtonSpinner = () => (
  <>
    <svg
      viewBox="0 0 43 43"
      className={`duc-btn-spinner `}
      aria-label={'Loading'}
    >
      <g>
        <circle
          className="duc-btn-spinner-inner"
          r="20"
          cx="21.5"
          cy="21.5"
          fill="none"
        ></circle>
        <circle
          className="duc-btn-spinner-outer"
          r="20"
          cx="21.5"
          cy="21.5"
          fill="none"
        ></circle>
      </g>
    </svg>
    <style jsx>
      {`
        .duc-btn-spinner g {
          animation: duc-btn-spinner 2.25s linear infinite;
          transform-origin: center center;
        }
        .duc-btn-spinner-inner {
          stroke-width: 3;
          stroke: #878c94;
          opacity: 0.25;
        }
        .duc-btn-spinner-outer {
          stroke-width: 3;
          stroke-dasharray: 89, 200;
          stroke-dashoffset: 0;
          stroke: #009fdb;
          animation: duc-btn-spinner-outer 1.6875s ease-in-out infinite;
          stroke-linecap: round;
        }
        @keyframes duc-btn-spinner {
          100% {
            transform: rotate(360deg);
          }
        }
        @keyframes duc-btn-spinner-outer {
          0% {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0;
          }
          50% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -35px;
          }
          100% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -124px;
          }
        }
      `}
    </style>
  </>
);
